import React, { createContext, useContext } from 'react';
import { warn } from '../../utils/error-logging';
const ConfigContext = createContext(undefined);
export const useConfig = () => {
    const config = useContext(ConfigContext);
    if (!config) {
        throw new Error('Content Component Library: No config found. `useConfig` must be called from within a ContentComponentLibraryProvider that has a required config passed to it.');
    }
    return config;
};
export const ContentComponentLibraryProvider = ({ children, config, }) => {
    if (!config) {
        warn('Content Component Library: A config must be provided.');
    }
    return React.createElement(ConfigContext.Provider, { value: config }, children);
};
//# sourceMappingURL=index.js.map